import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Inject, ElementRef, Output, EventEmitter, ComponentFactoryResolver } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogLookupUsersGroupsComponent } from 'src/app/+home/shared/components/dialog-lookup-users-groups/dialog-lookup-users-groups.component';
import { User } from 'src/shared/models/user.class';
import {FormControl} from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-dialog-body-task',
  templateUrl: './dialog-body-task.component.html',
  styleUrls: ['./dialog-body-task.component.scss']
})
export class DialogBodyTaskComponent implements OnInit {

  @Output() emitAffectto: EventEmitter<{affectto,email}> = new EventEmitter();

  description: any;
  title: any;
  affect = false;
  mySet = [];
  affectto: any[] = [];
  file: File;
  fileName = '';
  today: string;

  constructor(
    public dialogRef: MatDialogRef<DialogBodyTaskComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private elementRef: ElementRef,
    private dialog: MatDialog,  
    private http: HttpClient
  ) {}
    
  ngOnInit(){
    
    this.data.dueDate = this.data.dueDate.split('T')
    this.data.dueDate = this.data.dueDate[0]

    if(this.data.affectto){
      this.affectto = this.data.affectto
    }
    
    if(this.affectto){
      this.affectto.forEach((element) => {
        if (!this.mySet.includes(element)) {
          if(element !=null){
            this.mySet.push(element);
          }
        }
       });  
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  affectTo(){
    const dialogRef = this.dialog.open(DialogLookupUsersGroupsComponent, {
      width: '60%',
      height: '45%',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Ajout effectué
        this.affectto.push(result.affect.toString())
        const email =result.email;
      }
    });
    this.ngOnInit()
  }

  formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

  onFileSelected(event) {
    this.file = event.target.files[0];

    if (this.file) {
        this.fileName = this.file.name;
        const formData = new FormData();
        formData.append("thumbnail", this.file);
        const upload$ = this.http.post("alfresco/api/thumbnail-upload", formData);
        upload$.subscribe();
    }
}
  public onValidate() {
    this.dialogRef.close(this.affectto);
    }

  getScrollHeight(elm){
    let savedValue = elm.value
    elm.value = ''
    elm._baseScrollHeight = elm.scrollHeight
    elm.value = savedValue
}

  onExpandableTextareaInput({ target:elm }){
  // make sure the input event originated from a textarea and it's desired to be auto-expandable
  if( !elm.classList.contains('autoExpand') || elm.nodeName != 'TEXTAREA' ) return
  
    var minRows = elm.getAttribute('data-min-rows')|0, rows;
    !elm._baseScrollHeight && this.getScrollHeight(elm)

    elm.rows = minRows
    rows = Math.ceil((elm.scrollHeight - elm._baseScrollHeight) / 16)
    elm.rows = minRows + rows
}

ngAfterViewInit(){
  document.addEventListener('input', this.onExpandableTextareaInput)}

}

